import { parseEther } from 'ethers/lib/utils';

// src/constants.ts
var MAX_TICK_SPACING = 30;
var DEFAULT_PD_SLUGS = 5;
var DAY_SECONDS = 24 * 60 * 60;
var ETH_ADDRESS = "0x0000000000000000000000000000000000000000";
var DEFAULT_INITIAL_VOTING_DELAY = 7200;
var DEFAULT_INITIAL_VOTING_PERIOD = 50400;
var DEFAULT_INITIAL_PROPOSAL_THRESHOLD = BigInt(0);
var WAD = BigInt(10 ** 18);
var WAD_STRING = parseEther("1").toString();

export { DAY_SECONDS, DEFAULT_INITIAL_PROPOSAL_THRESHOLD, DEFAULT_INITIAL_VOTING_DELAY, DEFAULT_INITIAL_VOTING_PERIOD, DEFAULT_PD_SLUGS, ETH_ADDRESS, MAX_TICK_SPACING, WAD, WAD_STRING };
//# sourceMappingURL=chunk-THEIM6DM.mjs.map
//# sourceMappingURL=chunk-THEIM6DM.mjs.map